import getClientInfo from '../../clients';

function Footer(_props) {
  const clientInfo = getClientInfo();
  let text = `Lifepowr © ${new Date().getFullYear()}`;

  if (clientInfo) {
    text = clientInfo.footer ?? '';
  }

  return <div>{text}</div>;
}

export default Footer;
